export default "__VITE_ASSET__73e55a98__"